import { FC } from "react";
import {
    ReviewHeader,
    ReviewHeaderDate,
    ReviewText,
    Card,
    ReviewLogo,
    ReviewLinkArrows,
} from "./style";

type ReviewCardProps = {
    image?: string;
    imageHeight?: string;
    date: string;
    text?: string;
    externalHref: string;
};

const defaultImage = "index/img_revies.png";

const ReviewCard: FC<ReviewCardProps> = ({
    image = defaultImage,
    imageHeight = "48px",
    date,
    text,
    externalHref,
}) => (
    <Card rel='noopener noreferrer' href={`${externalHref}`}>
        <ReviewHeader>
            <ReviewLogo
                loading='lazy'
                imageHeight={imageHeight}
                src={`${process.env.PUBLIC_URL}/${image}`}
                alt='header-photo'
            />
            <ReviewHeaderDate>{date}</ReviewHeaderDate>
        </ReviewHeader>
        <ReviewText>{text}</ReviewText>
        <ReviewLinkArrows src='index/link_arrows.svg' />
    </Card>
);

export default ReviewCard;
